//styles
import { styled } from '@nykaa/ui-components';

//components
import BaseButton from '@nykaa/ui-components/Button';

export const Button = styled(BaseButton)`
  border: ${({ theme }) => `1px solid ${theme.colors.textOutline}`};
  ${({ theme }) => theme.typography.buttonSmall};
  background: ${({ theme }) => theme.colors.surface};

  ${({ theme }) =>
    `padding: ${theme.spacing.spacing10} ${theme.spacing.spacing60};
     border-radius: ${theme.borders.buttonBorderRadius};
  `};

  i {
    border: none;
    padding: 0;
    margin-top: ${({ theme }) => theme.spacing.spacing20};
  }

  &:active {
    background: ${({ theme }) => theme.colors.surface};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.surface};
  }
`;
